import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { images: Array }

  connect() {
    this.currentIndex = 0
    this.interval = setInterval(() => this.nextImage(), 3000)
  }

  disconnect() {
    clearInterval(this.interval)
  }

  nextImage() {
    this.element.style.backgroundImage =
      `url(/images/${this.imagesValue[this.currentIndex]})`
    this.currentIndex = (this.currentIndex + 1) % this.imagesValue.length
  }
}
